// Registers the service worker in production and for PWABuilder / PWA audit tools.

export function register() {
  const isPrerendering = /ReactSnap/i.test(navigator.userAgent) || /HeadlessChrome/i.test(navigator.userAgent);
  if (!isPrerendering && 'serviceWorker' in navigator) {
    const baseUrl = import.meta.env.BASE_URL || '/';
    const swUrl = `${baseUrl}serviceworker.js`;

    const doRegister = () => {
      navigator.serviceWorker.register(swUrl).catch((error) => {
        console.error('Service worker registration failed:', error);
      });
    };

    if (document.readyState === 'complete') {
      doRegister();
    } else {
      window.addEventListener('load', doRegister);
    }
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
